import { API_BASE_URL } from '@/config/api'
import { parseWith } from '@/lib/api-parse'
import type { z } from 'zod'

const PUBLIC_HEADERS: HeadersInit = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'ngrok-skip-browser-warning': 'true',
}

export { PUBLIC_HEADERS }

export const PUBLIC_AUTH_HEADERS: HeadersInit = {
  ...PUBLIC_HEADERS,
  'X-Imobdesk-Entry-App': 'admindesk',
}

type ResponseParser<T> = z.ZodType<T>

type PublicFetchOptions = {
  credentials?: RequestCredentials
  headers?: HeadersInit
}

async function readJsonResponse(response: Response): Promise<unknown> {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(
      (error as { message?: string })?.message || 'Erro na requisição',
    )
  }
  return response.json()
}

export async function publicGetParsed<T>(
  path: string,
  schema: ResponseParser<T>,
  options?: PublicFetchOptions,
): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers: { ...PUBLIC_HEADERS, ...options?.headers },
    credentials: options?.credentials,
  })
  const wire = await readJsonResponse(response)
  return parseWith(schema, wire)
}

export async function publicPostParsed<T>(
  path: string,
  body: unknown,
  schema: ResponseParser<T>,
  options?: PublicFetchOptions,
): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: { ...PUBLIC_HEADERS, ...options?.headers },
    credentials: options?.credentials ?? 'include',
    body: JSON.stringify(body),
  })
  const wire = await readJsonResponse(response)
  return parseWith(schema, wire)
}
